import React, {Dispatch, SetStateAction, useState} from 'react';
import Theme from '../../../styles/models/theme';
import CircleIconButton from '../../atoms/Buttons/CircleIconButton';
import {InputField, InputContainer, ChatInputContainer} from './styles';
import Clock from '../../../assets/icons/Send.svg';
import Emoji from '../../../assets/icons/Emoji.svg';

interface InputProps {
  type: string;
  placeholder: string;
  label?: string;
  theme: Theme;
  value: any;
  onChange: Dispatch<SetStateAction<any>>;
  helperText?: boolean;
  helperValue?: string;
  onSend?: () => void;
  buttonDisabled?: boolean;
}

const ChatInput: React.FC<InputProps> = ({
  type,
  placeholder,
  theme,
  onChange,
  value,
  onSend,
  buttonDisabled,
}) => {
  return (
    <InputContainer>
      <ChatInputContainer theme={theme}>
        <InputField
          type={type}
          onChange={e => onChange(e.target.value)}
          value={value}
          placeholder={placeholder}
          theme={theme}
        />
      </ChatInputContainer>
      <CircleIconButton
        src={Clock}
        onClick={onSend}
        submit
        disabled={buttonDisabled}
      />
    </InputContainer>
  );
};

export default ChatInput;
